import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { getDisplayAmount } from "./ManageSubscriptionForm";
import { useTranslation } from "react-i18next";
import { IProduct } from "../../services/dashboard.services";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subItemBox: {
      paddingBottom: "20px",
    },
    productText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "0.9rem",
      height: "20px",
    },
    subTextGrid: {
      color: theme.palette.dark.main,
      width: "45px",
    },
    itemText: {
      color: theme.palette.dark.main,
      fontSize: "0.85rem",
      height: "20px",
    },
    quantityBox: {
      display: "flex",
      justifyContent: "center",
    },
    productBox: {
      display: "flex",
    },
  })
);

export default function CurrentSubscriptionItemLayout(props: IProps) {
  // Component styles
  const classes = useStyles();
  const { t } = useTranslation();
  const { amount, quantity, product } = props;
  /* Hooks */
  return (
    <Box className={classes.subItemBox}>
      <Typography className={classes.productText}>
        {product.name} {t("gateways")}
      </Typography>
      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>Price:</Grid>
          <Grid>
            {getDisplayAmount(amount / 100, product.country)} {t("each")}
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>{t("quantity")}</Grid>
          <Grid className={classes.quantityBox}>{quantity}</Grid>
        </Grid>
      </Box>
      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>{t("total") + ":"}</Grid>
          <Grid>
            {getDisplayAmount((amount / 100) * quantity, product.country)}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

interface IProps {
  amount: number;
  id: string;
  quantity: number;
  productID: string;
  product: IProduct;
}
